<template>
    <div class="modal fade text-left show" id="seizureModal" tabindex="3" role="dialog" ref="seizureWindow">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel1">{{ $t("labels.seizure") }} - {{ formatDate(seizure.occuredOn) }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form class="form">
                      <seizure-form :seizure="seizure" v-on:editorinput="editorChanged" v-on:imagedeleted="imageDeleted" ref="editseizure" />
                      <div class="form-actions">
                        <button type="button" class="btn btn-success" @click.prevent="$emit('updateseizure', false)">
                          <i class="icon-note"></i> {{ $t("labels.save") }}
                        </button>
                        <button type="button" class="btn btn-success" @click.prevent="$emit('updateseizure', true)">
                          <i class="icon-note"></i> {{ $t("labels.saveAndNew") }}
                        </button>
                        <button type="button" class="btn btn-warning" @click.prevent="$emit('deleteseizure')"  v-if="$attrs.id != 'newSeizureModal'">
                          <i class="icon-note"></i> {{ $t("labels.delete") }}
                        </button>
                      </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeSeizureModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SeizureForm from '@/components/seizure/SeizureForm.vue'
import moment from 'moment'

export default {
    props: ["seizure"],
    components: {
        SeizureForm
    },
    methods: {
      editorChanged() {
        console.log(this.seizure.notes)
      },
      imageDeleted(index) {
        this.$emit('imagedeleted', index)
      },
      formatDate(date) {
        return moment(new Date(date)).format('DD/MM/YYYY')
      }
    }
}
</script>
